var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',{staticClass:"show-tooltip",staticStyle:{"text-decoration":"underline"}},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('i',{staticClass:"fa fa-question-circle"})]),_c('span',{staticClass:"tooltip-text",style:(_vm.textStyles),domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }